import { evaluateRule } from "./documentRules";

export const shouldShowDocument = (doc, context) => {
  if (doc.requirementType === "MANDATORY") return true;
  if (doc.requirementType === "OPTIONAL") return true;
  if (doc.requirementType === "CONDITIONAL")
    return evaluateRule(doc.rule, context);
  return false;
};

export const isRequiredDocument = (doc, context) => {
  if (doc.requirementType === "MANDATORY") return true;
  if (doc.requirementType === "CONDITIONAL")
    return evaluateRule(doc.rule, context);
  return false;
};
